import type { FaireProductEntity } from "../../entity_types/product";

export const p_mv9rw8pyvz: FaireProductEntity = {
  token: "p_mv9rw8pyvz",
  type: "product",
  name: "Easily Distracted By Books Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/424b9a3df94dc4c0de02c261d99c05688ff7870e452d6702257cebdfb4e3efdd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/332e4e082d9a85bb078e962fdb4a5680902516d6d8fd1b7961c864de27c8d668.jpeg",
    "https://cdn.faire.com/fastly/957ebbbdcc6ab9fd067bcc93d057388236928c460e823bbc476b5775c373661f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/c0ce9485d59fbe37bb41b1ca18ee2a7b8d2bb3fafb9a368f2716a1a2e36257cb.jpeg",
    "https://cdn.faire.com/fastly/f4e854fbff94eeb95d3aac67b3e866c25bc652bb3611e0594ae1623a5f325342.jpeg",
    "https://cdn.faire.com/fastly/926ce0f1512639359c36a07d7c1afbea401733f009892aba8efd3dbf25c4f6c4.jpeg",
    "https://cdn.faire.com/fastly/66b113b3571af347758f99fab323465c6ba035b842c2c538e5f806e916d5bcb6.jpeg"
  ],
  priceDollars: 6.75,
  description: "For feet that wander... mostly to the bookshelf. Make your whole vibe \"just one more chapter\" with these cozy socks. Great for lounging on the couch or speeding through the climax.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:12.763Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
